export const SET_STAMP_TYPES = "setVenderTypes";
export const SET_STAMP_TYPES_TOTAL = "setVenderTypesTotal";
export const SET_LOADING = "setLoading";

export default {
  [SET_STAMP_TYPES](state, stamp_types) {
    state.stamp_types = stamp_types;
  },
  [SET_STAMP_TYPES_TOTAL](state, totalCount) {
    state.totalCount = totalCount;
  },
  [SET_LOADING](state, loading) {
    state.loading = loading;
  },
};
